
export const _genAutosaveStatusMsg = (saveStatus) => {
    return saveStatus === "idle"
      ? "Autosave Inactive"
      : saveStatus === "loading"
      ? "Saving..."
      : saveStatus === "error"
      ? "Save Failed"
      : saveStatus === "success" && "Saved!";
  };